import { Box, Center, Skeleton, Text } from '@chakra-ui/react'
import { format } from 'date-fns'
import React, { useState } from 'react'
import { Button } from '../../../components/Button'
import { Table, TableDataProp } from '../../../components/table/Table'
import { IOfficeAssignationRequest } from '../../../types'
import { TeamLink } from './TeamLink'
import { RenderStatus } from '../../../components/RenderStatus'
import { ReviewOfficeAssignationRequestModal } from '../Modals/ReviewOfficeAssignationRequestModal'

interface IInputParams {
  pendingRequests: IOfficeAssignationRequest[] | undefined
  status?: string
  revalidateRequests: () => void
  pagination?: {
    fetchMoreResults: () => void
    hasMoreResults: boolean
    isLoading: boolean
    count: number
  }
}

export const OfficeAssignationRequests: React.FC<IInputParams> = (input) => {
  const { pendingRequests, pagination, revalidateRequests } = input
  const titleStatus = input.status ? input.status.toLowerCase() : 'All'

  const [requestToReview, setRequestToReview] = useState<
    IOfficeAssignationRequest | undefined
  >()

  const loading = pendingRequests === undefined

  const reviewRequestAction = {
    text: 'Review Request',
    testIdPrefix: 'review-request',
    action: (rowId) => {
      const requestObj = pendingRequests!.find((obj) => obj.id === rowId)
      if (requestObj) {
        setRequestToReview(requestObj)
      }
    }
  }
  const tableData = pendingRequests
    ? pendingRequests.map((request) => {
        const cleanedData = {
          id: TableDataProp(request.id),
          test_prefix: TableDataProp(request.requested_by?.name),
          status: TableDataProp(RenderStatus(request.status)),
          requested_by: [
            TableDataProp(request.requested_by?.name),
            TableDataProp(request.requested_by?.email)
          ],
          office: [
            TableDataProp(
              `${request.office?.name} @ ${request.office?.location.name}`
            )
          ],

          organization: TableDataProp(
            TeamLink({
              organizationId: request.organization.id,
              organizationName: request.organization.name
            })
          ),
          start_date: TableDataProp(
            format(Date.parse(request.start_date), 'dd/MM/yyyy')
          ),
          end_date: TableDataProp(
            request.end_date
              ? format(Date.parse(request.end_date), 'dd/MM/yyyy')
              : 'No End Date'
          ),

          override_value: [
            TableDataProp(
              request.override_value ? `$${request.override_value}` : ''
            )
          ]
        }

        const actions: any = []
        if (request.status === 'PENDING') {
          actions.push(reviewRequestAction)
        }

        cleanedData['actions'] = TableDataProp(actions)

        return cleanedData
      })
    : []

  return (
    <div style={{ width: '100%', padding: '16px' }}>
      <Box my="3" w="100%">
        <Box display="flex" mb={3} alignItems="baseline">
          <Text
            mb={0}
            mr={3}
            color="headingPrimary"
            fontSize="lg"
            textTransform="capitalize"
          >
            Office Assignation Requests
          </Text>
          <Text fontSize="xs" color="grey">
            {pagination
              ? pagination.count
              : pendingRequests
              ? pendingRequests.length
              : ''}{' '}
            Total
          </Text>
        </Box>

        <Table
          pageSize={pagination ? 100 : 10}
          headers={[
            { header: 'id', accessor: 'id', show: false },
            { header: 'test_prefix', accessor: 'test_prefix', show: false },
            {
              header: 'Status',
              accessor: 'status',
              show: true,
              width: 1.25 / 12
            },
            {
              header: 'Requested By',
              accessor: 'requested_by',
              show: true,
              width: 2.2 / 12
            },
            {
              header: 'Office',
              accessor: 'office',
              show: true,
              width: 1.5 / 12
            },
            {
              header: 'Team',
              accessor: 'organization',
              show: true,
              width: 1.5 / 12
            },
            {
              header: 'Start Date',
              accessor: 'start_date',
              show: true,
              width: 1 / 12
            },
            {
              header: 'End Date',
              accessor: 'end_date',
              show: true,
              width: 1 / 12
            },
            {
              header: 'Overridden Value',
              accessor: 'override_value',
              show: true,
              width: 1.25 / 12
            },
            { header: '', accessor: 'actions', show: true, width: 0.5 / 12 }
          ]}
          data={tableData}
          loading={loading}
        />
      </Box>
      {pagination && (
        <Center display={'block'}>
          {pagination.isLoading && <Skeleton my={3} w={'100%'} h="60px" />}

          {pagination.hasMoreResults &&
            pendingRequests &&
            pendingRequests?.length > 0 && (
              <Center>
                <Button
                  disabled={pagination.isLoading || !pagination.hasMoreResults}
                  onClick={pagination.fetchMoreResults}
                  mt={3}
                  p={3}
                >
                  Fetch more requests
                </Button>
              </Center>
            )}
        </Center>
      )}

      <ReviewOfficeAssignationRequestModal
        request={requestToReview}
        closeModalCallback={() => {
          setRequestToReview(undefined)
          revalidateRequests()
        }}
      />
    </div>
  )
}
